<template>
  <div>
    <v-card>
      <v-card-title>Set permissions</v-card-title>
      <v-card-text>
        <v-text-field
          label="Username"
          :rules="usernameRules"
          style="margin-top: 10px;"
          suffix="@betmakers.com"
          outlined
          dense
          v-model="username"
        ></v-text-field>
        <v-card-title class="pl-0 pb-0" style="color: #000;">
          Select roles
          <v-btn color="#fe3d89" fab x-small class="ml" style="margin-bottom: 5px;" @click="roleDialog = true">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-card-title>
        <v-switch v-model="permissions" inset label="Admin" value="*" hide-details :disabled="!permissions.includes('*') && permissions.length > 0"></v-switch>
        <v-switch v-for="role in getRoles" :key="role.Id" v-model="permissions" inset :label="role.roleName" :value="role.id" hide-details :disabled="permissions.includes('*')"></v-switch>
        <!-- <v-switch v-model="permissions" inset label="API" value="1" hide-details :disabled="permissions.includes('*')"></v-switch>
        <v-switch v-model="permissions" inset label="Terminals" value="2" hide-details :disabled="permissions.includes('*')"></v-switch>
        <v-switch v-model="permissions" inset label="Futures" value="3" hide-details :disabled="permissions.includes('*')"></v-switch>
        <v-switch v-model="permissions" inset label="Sports" value="4" hide-details :disabled="permissions.includes('*')"></v-switch>
        <v-switch v-model="permissions" inset label="DynamicOdds" value="5" hide-details :disabled="permissions.includes('*')"></v-switch> -->
      </v-card-text>
      <v-card-actions style="padding-bottom: 26px; padding-top: 26px;">
        <v-btn small color="success" style="position: absolute; right: 25px;" @click="savePermissions" :disabled="username === ''">Save</v-btn>
        <v-btn small color="error" style="position: absolute; right: 90px;" @click="cancelNewUser" :disabled="username === ''">Cancel</v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="roleDialog" max-width="800px" persistent>
      <v-card>
        <v-toolbar color="#425058" dark dense>
          <div class="titleBar-content">
            <v-toolbar-title class="raceResults-title"> Create a Role </v-toolbar-title>
            <v-btn class="cancelButton" icon small @click="roleDialog = false" ><v-icon class="white--text">mdi-close</v-icon></v-btn>
          </div> 
          <v-spacer></v-spacer>
        </v-toolbar>
         <v-form ref="createRoleForm">
          <v-card-text>
          <v-text-field
            class="mb-3"
            label="Role Name"
            outlined
            dense
            :rules="[(v) => !!v || 'Role Name is required']"
            v-model="roleName"
            style="margin-top: 10px;"
          ></v-text-field>
          <div>Resources</div>
          <v-row>
            <v-col>
              <v-treeview
                v-model="selectedResources"
                :items="resourceTree"
                selection-type="leaf"
                selectable
                return-object
                item-key="uri"
                @input="onSelectionChange"
              >
                <template v-slot:append="{ item, selected}">
                   <v-select
                    v-if="item.uri !='tbm-cp-all'"
                    style="max-width:365px;"
                    :disabled="!selected"
                    dense
                    hide-details
                    outlined
                    v-model="item.actions"
                    chips
                    :items="actions"
                    item-text="name"
                    item-value="value"
                    label="Permissions"
                    persistent-hint
                    small-chips
                    single-line
                    @change="onPermisionChange(item)"
                  ></v-select>
                </template>
              </v-treeview>
            </v-col>
          </v-row>
        </v-card-text>
         </v-form>
         
        <v-card-actions style="padding-bottom: 26px; padding-top: 26px;">
          <v-btn small color="success" style="position: absolute; right: 25px;" @click="saveNewRole" :disabled="createDisabled">Save</v-btn>
          <v-btn small color="error" style="position: absolute; right: 90px;" @click="cancelNewRole">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { RESOURCETREEBASETEMPLATE, ROLEACTIONS, RESOURCENAMES, ROLEACTIONCODE } from '../common/constants'
import { mapActions, mapGetters } from 'vuex'

  export default {
    props: {
      userEditObj: {
        type: Object,
      },
      isEditing: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      usernameRules: [
        
      ],
      permissions: [],
      roleDialog: false,
      roleName: '',
      username: '',
      selectedResources:[],
      actions: ROLEACTIONS
    }),
    async created () {
      await this.fetchTerminalVenues()
    },
    watch:{
      userEditObj: {
        handler: function (val) {
          if(val && this.isEditing){
            this.username = this.userEditObj.username?.replace('@betmakers.com','')
            this.permissions = JSON.parse(this.userEditObj.roles)
          }
        },
        immediate: true
      }
    },
    computed: {
      ...mapGetters(['getRoles']),
      ...mapGetters('terminalStore',['getTerminalVenues']),
      resourceTree() {
        let tree = RESOURCETREEBASETEMPLATE
        let venues = [...new Set(this.getTerminalVenues.map(v=>({venueCode:v.venueCode})))]
        tree[0].children.find(c=>c.uri == RESOURCENAMES.TERMINALS).children.forEach(c=> {
          let children = []
          venues.forEach(v=> {
          children.push({
            uri:`${c.uri}-${v.venueCode}`,
            name: v.venueCode,
            parent: c.uri
          })
        })
          c.children = children
        })
        return tree
      },
      createDisabled(){
        return this.selectedResources.length == 0 || this.selectedResources.findIndex(r=>r.actions == undefined) > -1
      }
    },
    methods: {
      ...mapActions(['saveUserPermissions', 'saveRole']),
      ...mapActions('terminalStore',['fetchTerminalVenues']),
      savePermissions () {
        this.saveUserPermissions({ username: `${this.username}@betmakers.com`, permissions: this.permissions })
        this.cancelNewUser()
      },
      saveNewRole () {
        if (this.$refs.createRoleForm.validate()){
          let permissions = []
          this.selectedResources.forEach(p=> {
            let permission = {...p}
            permission.actions = p.actions == ROLEACTIONCODE.FULL ? [ROLEACTIONCODE.READ, ROLEACTIONCODE.FULL] : [ROLEACTIONCODE.READ]
            permissions.push(permission)
          })
          this.saveRole({ roleName: this.roleName, permissions: permissions})
          this.roleName = ''
          this.roleDialog = false
          this.$emit('finished')
        } 
 
      },
      cancelNewUser () {
        this.permissions = []
        this.username = ''
        this.$emit('finished')
      },
      cancelNewRole () {
        this.roleDialog = false
        this.roleName = ''
        this.selectedResources = []
      },
      onSelectionChange(selections){
        console.log(selections)
      },
      onPermisionChange(val){
        if(val.actions == ROLEACTIONCODE.FULL){
          this.syncChildrenPermission(val, ROLEACTIONCODE.FULL)
        }
        console.log(val)
      },
      syncChildrenPermission(root, actionCode){
        if (root.children) {
          root.children.forEach(c=>{
            c.actions= actionCode
            this.selectedResources.find(r=>r.uri == c.uri).actions = actionCode
            this.syncChildrenPermission(c,actionCode)
          })
        }
      }
    },

  }
</script>
